/* src/app/components/status/status.component.css */
.status-container {
  padding: 4px;
}
.status-light {
  height: 16px;
  width: 16px;
  border-radius: 50%;
  margin-left: auto;
  margin-right: auto;
}
.online {
  background-color: green;
  box-shadow:
    rgba(0, 0, 0, 0.2) 0 -1px 7px 1px,
    inset #304701 0 -1px 9px,
    #89FF00 0 2px 12px;
}
.offline {
  background-color: #F00;
  box-shadow:
    rgba(0, 0, 0, 0.2) 0 -1px 7px 1px,
    inset #441313 0 -1px 9px,
    rgba(255, 0, 0, 0.5) 0 2px 12px;
}
.wait {
  background-color: #FF0;
  box-shadow:
    rgba(0, 0, 0, 0.2) 0 -1px 7px 1px,
    inset #808002 0 -1px 9px,
    #FF0 0 2px 12px;
}
/*# sourceMappingURL=status.component-YF4N5MTI.css.map */
